import axios from 'axios';

const publicSalesApi = axios.create({
  baseURL: '',
  timeout: 15000,
  headers: {
    Accept: 'application/json',
  },
});

export const createDemoRequest = (payload) => (
  publicSalesApi.post('/api/public/demonstracao', payload)
);

